import AssignProducts from "../components/AdminSideComponents/bookings/AssignProducts";
import ProductDetails from "../components/AdminSideComponents/products/ProductDetails";
import StaffDetails from "../components/AdminSideComponents/staff/StaffDetails";
import AdminCoupons from "../screens/auth/adminPanel/AdminCoupons.jsx";
import AdminInvoices from "../screens/auth/adminPanel/AdminInvoices";
import AdminInvoicesDetails from "../screens/auth/adminPanel/AdminInvoicesDetails.jsx";
import AdminPaymentQR from "../screens/auth/adminPanel/AdminPaymentQR";
import AdminProfile from "../screens/auth/adminPanel/AdminProfile";
import AdminSlotManagement from "../screens/auth/adminPanel/AdminSlotManagement";
import AdminSlotsAvailability from "../screens/auth/adminPanel/AdminSlotsAvailability";
import AdminTestimonials from "../screens/auth/adminPanel/AdminTestimonials.jsx";
import AllProducts from "../screens/auth/adminPanel/AllProducts";
import BannerManagement from "../screens/auth/adminPanel/BannerManagement.jsx";
import Blogs from "../screens/auth/adminPanel/Blog";
import Bookings from "../screens/auth/adminPanel/Bookings";
import Branch from "../screens/auth/adminPanel/Branch";
import Categories from "../screens/auth/adminPanel/Categories";
import Customers from "../screens/auth/adminPanel/Customers";
import Dashboard from "../screens/auth/adminPanel/Dashboard";
import Managers from "../screens/auth/adminPanel/Managers";
import Packages from "../screens/auth/adminPanel/Packages.jsx";
import ProductLedger from "../screens/auth/adminPanel/ProductLedger";
import ProductRequests from "../screens/auth/adminPanel/ProductRequests";
import Reports from "../screens/auth/adminPanel/Reports";
import Services from "../screens/auth/adminPanel/Services";
import StaffManagement from "../screens/auth/adminPanel/StaffManagement";
import SubCategories from "../screens/auth/adminPanel/SubCategories";
import Vendors from "../screens/auth/adminPanel/Vendors";
import RequestStats from "../screens/auth/staffPanel/RequestStats";
import StaffAllProducts from "../screens/auth/staffPanel/StaffAllProducts";
import StaffDashboard from "../screens/auth/staffPanel/StaffDashboard";
import StaffEarnings from "../screens/auth/staffPanel/StaffEarnings";
import StaffJobDetails from "../screens/auth/staffPanel/StaffJobDetails";
import StaffMyJobs from "../screens/auth/staffPanel/StaffMyJobs";
import StaffStatus from "../screens/auth/staffPanel/StaffStatus";
import AdminLogin from "../screens/nonAuth/AdminLogin";
import ForgotPassword from "../screens/nonAuth/ForgotPassword";
import Login from "../screens/nonAuth/Login";
import Register from "../screens/nonAuth/Register";
import About from "../screens/users/About";
import Blog from "../screens/users/Blog";
import Catalog from "../screens/users/Catalog";
import Contact from "../screens/users/Contact";
import Home from "../screens/users/Home";
import UserBookingDetails from "../screens/users/UserBookingDetails";
import UserBookings from "../screens/users/UserBookings";
import UserPackages from "../screens/users/UserPackages.jsx";
import UserProfile from "../screens/users/UserProfile";
import UserServiceCart from "../screens/users/UserServiceCart";
import UserServices from "../screens/users/UserServices";

export const adminRoutes = [
  {
    path: "/dashboard",
    component: <Dashboard />,
    permission: "dashboard",
  },
  {
    path: "/categories",
    component: <Categories />,
    permission: "categories",
  },
  {
    path: "/sub-categories",
    component: <SubCategories />,
    permission: "sub-categories",
  },
  {
    path: "/admin/services",
    component: <Services />,
    permission: "services",
  },
  {
    path: "/bookings",
    component: <Bookings />,
    permission: "bookings",
  },
  {
    path: "/branch",
    component: <Branch />,
  },
  {
    path: "/bookings/assign-products/:bookingId",
    component: <AssignProducts />,
    permission: "assigned-products",
  },
  {
    path: "/staff-management/manager",
    component: <Managers />,
  },
  {
    path: "/staff-management/staff",
    component: <StaffManagement />,
    permission: "staff",
  },
  {
    path: "/staff-management/staff/:staffId",
    component: <StaffDetails />,
    permission: "staff",
  },
  {
    path: "/customers",
    component: <Customers />,
    permission: "customers",
  },
  {
    path: "/products-management/product-requests",
    component: <ProductRequests />,
    permission: "product-requests",
  },
  {
    path: "/products-management/all-products",
    component: <AllProducts />,
    permission: "all-products",
  },
  {
    path: "/products-management/:productId",
    component: <ProductDetails />,
  },
  {
    path: "/products-management/ledger",
    component: <ProductLedger />,
  },
  {
    path: "/reports",
    component: <Reports />,
    permission: "reports",
  },
  {
    path: "/invoices",
    component: <AdminInvoices />,
    permission: "invoices",
  },
  {
    path: "/invoices/:id",
    component: <AdminInvoicesDetails />,
  },
  {
    path: "/admin/payment-qr",
    component: <AdminPaymentQR />,
  },
  {
    path: "/admin/blog",
    component: <Blogs />,
    permission: "blogs",
  },
  {
    path: "/admin-profile",
    component: <AdminProfile />,
  },
  {
    path: "/admin/banners",
    component: <BannerManagement />,
  },
  {
    path: "/admin/testimonials",
    component: <AdminTestimonials />,
  },
  {
    path: "/admin/coupons",
    component: <AdminCoupons />,
  },
  {
    path: "/vendors",
    component: <Vendors />,
  },
  {
    path: "/admin/packages",
    component: <Packages />,
  },
  {
    path: "/slots",
    component: <AdminSlotManagement />,
    permission: "slots",
  },
  {
    path: "/slots-availability",
    component: <AdminSlotsAvailability />,
    permission: "slots-availability",
  },
];

export const staffRoutes = [
  {
    path: "/dashboard-staff",
    component: <StaffDashboard />,
  },
  {
    path: "/my-jobs",
    component: <StaffMyJobs />,
  },
  {
    path: "/my-jobs/:type/:bookingId",
    component: <StaffJobDetails />,
  },
  {
    path: "/all-products",
    component: <StaffAllProducts />,
  },
  {
    path: "/request-stats",
    component: <RequestStats />,
  },
  {
    path: "/status",
    component: <StaffStatus />,
  },
  {
    path: "/staff-profile",
    component: <AdminProfile />,
  },
  {
    path: "/earnings",
    component: <StaffEarnings />,
  },
];

export const adminNonAuthRoutes = [
  {
    path: "/admin-login",
    component: <AdminLogin />,
    adminNonAuth: true,
  },
  {
    path: "/admin-forgot-password",
    component: <ForgotPassword />,
    adminNonAuth: true,
  },
];

export const userNonAuthRoutes = [
  {
    path: "/login",
    component: <Login />,
  },
  {
    path: "/register",
    component: <Register />,
  },
];

export const userRoutes = [
  {
    path: "/",
    component: <Home />,
  },
  {
    path: "/about",
    component: <About />,
  },
  {
    path: "/services",
    component: <UserServices />,
  },
  {
    path: "/packages",
    component: <UserPackages />,
  },
  {
    path: "/services/:id",
    component: <UserServices />,
  },
  {
    path: "/blog",
    component: <Blog />,
  },
  {
    path: "/contact",
    component: <Contact />,
  },
  {
    path: "/catalog",
    component: <Catalog />,
  },
  {
    path: "/my-bookings",
    // component: <UserBookings />,
    component: <UserBookings />,
    protected: true,
  },
  {
    path: "/my-bookings/:type/:bookingId",
    component: <UserBookingDetails />,
    protected: true,
  },
  {
    path: "/user-profile",
    component: <UserProfile />,
    protected: true,
  },
  {
    path: "/service-cart",
    component: <UserServiceCart />,
    protected: true,
  },
];

// export const adminRoutes = [
//   {
//     path: "/dashboard",
//     component: <Dashboard />,
//   },
//   {
//     path: "/categories",
//     component: <Categories />,
//   },
//   {
//     path: "/sub-categories",
//     component: <SubCategories />,
//   },
//   {
//     path: "/admin/services",
//     component: <Services />,
//   },
//   {
//     path: "/bookings",
//     component: <Bookings />,
//   },
//   {
//     path: "/branch",
//     component: <Branch />,
//   },
//   {
//     path: "/bookings/assign-products/:bookingId",
//     component: <AssignProducts />,
//   },
//   {
//     path: "/staff-management/manager",
//     component: <BranchManager />,
//   },
//   {
//     path: "/staff-management/staff",
//     component: <BranchStaff />,
//   },
//   {
//     path: "/customers",
//     component: <Customers />,
//   },
//   {
//     path: "/products",
//     component: <Products />,
//   },
//   {
//     path: "/products/:productId",
//     component: <ProductDetails />,
//   },
//   {
//     path: "/reports",
//     component: <Reports />,
//   },
//   {
//     path: "/admin/payment-qr",
//     component: <AdminPaymentQR />,
//   },
//   {
//     path: "/admin/blog",
//     component: <Blogs />,
//   },
//   {
//     path: "/admin-profile",
//     component: <AdminProfile />,
//   },
//   {
//     path: "/banners",
//     component: <Banner />,
//   },
//   {
//     path: "/slots",
//     component: <AdminSlotManagement />,
//   },
//   {
//     path: "/slots-availability",
//     component: <AdminSlotsAvailability />,
//   },
// ];

// export const staffRoutes = [
//   {
//     path: "/dashboard-staff",
//     component: <StaffDashboard />,
//   },
//   {
//     path: "/my-jobs",
//     component: <StaffMyJobs />,
//   },
//   {
//     path: "/my-jobs/:bookingId",
//     component: <StaffJobDetails />,
//   },
//   {
//     path: "/assiged-products",
//     component: <StaffAssignedProducts />,
//   },
//   {
//     path: "/status",
//     component: <StaffStatus />,
//   },
//   {
//     path: "/staff-profile",
//     component: <AdminProfile />,
//   },
//   {
//     path: "/earnings",
//     component: <StaffEarnings />,
//   },
// ];
